var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5547 13.5V11.5H7.55469V8.5L2.55469 12.5L7.55469 16.5V13.5H16.5547Z",
    fill: "#E81E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5547 3.5H11.5547C10.4517 3.5 9.55469 4.397 9.55469 5.5V9.5H11.5547V5.5H20.5547V19.5H11.5547V15.5H9.55469V19.5C9.55469 20.603 10.4517 21.5 11.5547 21.5H20.5547C21.6577 21.5 22.5547 20.603 22.5547 19.5V5.5C22.5547 4.397 21.6577 3.5 20.5547 3.5Z",
    fill: "#E81E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.52354d8132200f6f9e4633a52987d883.svg";
export { ForwardRef as ReactComponent };